module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_1.1b85c4d5.jpg";